import React, { useState } from 'react'
import { DatetimePicker, Popup } from 'react-vant'
import { useTranslation } from 'react-i18next'

interface BirthDateSelectorProps {
  year: string
  month: string
  day: string
  onYearChange: (year: string) => void
  onMonthChange: (month: string) => void
  onDayChange: (day: string) => void
}

const BirthDateSelector: React.FC<BirthDateSelectorProps> = ({
  year,
  month,
  day,
  onYearChange,
  onMonthChange,
  onDayChange
}) => {
  const { t } = useTranslation()
  const [showDatePicker, setShowDatePicker] = useState(false)

  // 将字符串日期转换为 Date 对象
  const currentDate = year && month && day 
    ? new Date(parseInt(year), parseInt(month) - 1, parseInt(day))
    : new Date()

  const handleConfirm = (date: Date) => {
    onYearChange(date.getFullYear().toString())
    onMonthChange((date.getMonth() + 1).toString().padStart(2, '0'))
    onDayChange(date.getDate().toString().padStart(2, '0'))
    setShowDatePicker(false)
  }

  return (
    <div className="grid grid-cols-3 gap-3">
      <div
        onClick={() => setShowDatePicker(true)}
        className="w-full px-4 h-11.5 border-[0.5px] border-[#808080] border-solid rounded-2.5 bg-white cursor-pointer flex items-center justify-between"
      >
        <span className={`text-3 ${year ? 'text-black' : 'text-[#1A1A1A]/30'}`}>
          {year || t('年份')}
        </span>
        <img src="/icon/select-down.svg" />
      </div>

      <div
        onClick={() => setShowDatePicker(true)}
        className="w-full px-4 h-11.5 border-[0.5px] border-[#808080] border-solid rounded-2.5 bg-white cursor-pointer flex items-center justify-between"
      >
        <span className={`text-3 ${month ? 'text-black' : 'text-[#1A1A1A]/30'}`}>
          {month || t('月份')}
        </span>
        <img src="/icon/select-down.svg" /> 
      </div>

      <div
        onClick={() => setShowDatePicker(true)}
        className="w-full px-4 h-11.5 border-[0.5px] border-[#808080] border-solid rounded-2.5 bg-white cursor-pointer flex items-center justify-between"
      >
        <span className={`text-3 ${day ? 'text-black' : 'text-[#1A1A1A]/30'}`}>
          {day || t('日')}
        </span>
        <img src="/icon/select-down.svg" />
      </div>

      <Popup
        visible={showDatePicker}
        onClose={() => setShowDatePicker(false)}
        position="bottom"
        round
      >
        <DatetimePicker
          type="date"
          title={t('选择出生日期')}
          minDate={new Date(1924, 0, 1)}
          maxDate={new Date()}
          value={currentDate}
          onConfirm={handleConfirm}
          onCancel={() => setShowDatePicker(false)}
          confirmButtonText={t('确定')}
          cancelButtonText={t('取消')}
        />
      </Popup>
    </div>
  )
}

export default BirthDateSelector